import { render, staticRenderFns } from "./BannerDetailsView.vue?vue&type=template&id=7fa94693&scoped=true"
import script from "./BannerDetailsView.vue?vue&type=script&lang=js"
export * from "./BannerDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa94693",
  null
  
)

export default component.exports